import { Header } from "src/app/common/request/base-request";
import { RequestHeader } from "src/app/school-erp/common/shared/header/request-header";
import { EmptyBody } from "./empty-body";

export class EmptyBodyRequest {
  header: Header = new Header();
  // meta: object = new Object();
  body: EmptyBody = new EmptyBody();
}